import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '../../components';
import { TextField } from '@material-ui/core';

const INITIAL_STATE = {
  isChecked: false,
  inputNumber: null,
  inputText: null,
  error: false,
  helperText: null,
};

class ChecklistItem extends Component {
  constructor(props) {
    super(props);

    this.state = INITIAL_STATE;
    this.onHandleCheck = this.onHandleCheck.bind(this);
  }
  componentDidMount() {
    const { checklistItemAnswer } = this.props;
    if (checklistItemAnswer) {
      this.setState({
        isChecked: checklistItemAnswer.isChecked,
        inputNumber: checklistItemAnswer.inputNumber,
        inputText: checklistItemAnswer.inputText,
        id: checklistItemAnswer.id,
        checklistItemId: checklistItemAnswer.checklistItemId,
      });
      if (checklistItemAnswer.isChecked === true) {
        this.props.onUpdateScore(true);
      }
    }
  }

  onHandleCheck() {
    const checked = !this.state.isChecked;
    this.setState({
      isChecked: checked,
    });
    this.updateChecklistItemAnswer({
      isChecked: checked,
    });
  }

  handleInputNumberChange = (e) => {
    this.setState({
      inputNumber: e.target.value,
      hasChanged: true,
    });
    if (
      e.target.value > this.props.checklistItem.maxValue ||
      e.target.value < this.props.checklistItem.minValue
    ) {
      this.setState({
        error: true,
        helperText: 'Wert liegt außerhalb des Wertbereichs',
      });
    } else {
      this.setState({
        error: false,
        helperText: null,
      });
    }
    this.updateChecklistItemAnswer();
  };

  handleInputTextChange = (e) => {
    const error = e.target.value !== this.props.checklistItem.answerText;

    this.setState({
      inputText: e.target.value,
      hasChanged: true,
      error,
      helperText: error ? 'Text stimmt nicht überein!' : null,
    });

    this.updateChecklistItemAnswer({
      inputText: e.target.value,
    });
  };

  updateChecklistItemAnswer(changes) {
    const dateTime = Date.now();
    const dateTimeString = new Date(dateTime).toISOString();
    this.props.onUpdate({
      id: this.state.id,
      inputText: this.state.inputText,
      inputNumber: this.state.inputNumber,
      checklistItemId: this.props.checklistItem.id,
      isChecked: this.state.isChecked,
      answeredCorrectly: !this.state.error,
      dateTime: dateTimeString,
      checklistRunId: this.props.checklistRunId,
      ...(changes || {}),
    });
    this.setState({ hasChanged: false });
    this.props.onUpdateScore(changes.isChecked);
  }

  render() {
    var checklistItemType = this.props.checklistItem.checklistItemType;
    if (!this.props.checklistItem) {
      return null;
    }
    if (checklistItemType === 'check') {
      return (
        <Checkbox
          label={
            <span
              dangerouslySetInnerHTML={{
                __html: this.props.checklistItem.text,
              }}
            ></span>
          }
          onCheck={this.onHandleCheck}
          checked={this.state.isChecked}
        ></Checkbox>
      );
    }
    if (checklistItemType === 'range') {
      return (
        <div>
          <Checkbox
            label={
              <span
                dangerouslySetInnerHTML={{
                  __html: this.props.checklistItem.text,
                }}
              ></span>
            }
            onCheck={this.onHandleCheck}
            checked={this.state.isChecked}
          ></Checkbox>
          <TextField
            error={this.state.error}
            helperText={this.state.helperText}
            label="Wert"
            type="number"
            value={this.state.inputNumber}
            onChange={this.handleInputNumberChange}
          />
        </div>
      );
    }
    if (checklistItemType === 'text') {
      return (
        <div>
          <Checkbox
            label={
              <span
                dangerouslySetInnerHTML={{
                  __html: this.props.checklistItem.text,
                }}
              ></span>
            }
            onCheck={this.onHandleCheck}
            checked={this.state.isChecked}
          ></Checkbox>
          <TextField
            error={this.state.error}
            helperText={this.state.helperText}
            label="Text"
            type="text"
            value={this.state.inputText}
            onChange={this.handleInputTextChange}
          />
        </div>
      );
    }
  }
}

const styles = {
  imageContainer: {
    maxHeight: 380,
    marginBottom: 20,
    marginTop: 10,
    textAlign: 'center',
    backgroundColor: '#f8f8f8',
  },
  imageStyle: {
    maxWidth: '100%',
    maxHeight: 380,
  },
};

ChecklistItem.propTypes = {
  checklistItem: PropTypes.object,
  onUpdateScore: PropTypes.func,
  checklistRunId: PropTypes.int,
  onUpdate: PropTypes.func,
  checklistItemAnswer: PropTypes.object,
};

ChecklistItem.defaultProps = {
  checklistItem: [],
};

export default ChecklistItem;



// WEBPACK FOOTER //
// ./src/app/main/checklist/checklistItem.js